import { render, staticRenderFns } from "./RequestManager.vue?vue&type=template&id=555366fb&scoped=true"
import script from "./RequestManager.vue?vue&type=script&lang=js"
export * from "./RequestManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555366fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555366fb')) {
      api.createRecord('555366fb', component.options)
    } else {
      api.reload('555366fb', component.options)
    }
    module.hot.accept("./RequestManager.vue?vue&type=template&id=555366fb&scoped=true", function () {
      api.rerender('555366fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/RequestManager.vue"
export default component.exports